import { PermissionsApi, RolesApi, SystemRolesApi } from '@evimo/client/apis';
import { createApiConfiguration } from '~/app/lib/api-config';

const config = createApiConfiguration();

export const rolesApi = new RolesApi(config);
export const systemRolesApi = new SystemRolesApi(config);
export const permissionsApi = new PermissionsApi(config);

export const authorizationRequestInit = { credentials: 'include' as const };
